import React from 'react';
import { Toaster } from "react-hot-toast";
import AppRoutes from '_config/routes/AppRoutes';
import "flag-icons/css/flag-icons.min.css";

const App = () => {

  return (
    <div className='w-screen h-screen'>
      <AppRoutes />
      <Toaster />
    </div>
  );
};


export default App;
